import { useMemo } from 'react'

import { CustomizableDashboard } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import { digObject } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'
import useUser from '@hooks/useUser'

import Content from '../dashboardModules/Content'
import ContentSidebar from '../dashboardModules/ContentSidebar'
import PageLayout from '../../../../components/PageLayout'

import { dashboardDefaultLayout, generateAvailableModules } from '../../utils/customizableDashboard'

const defaultState = {
  editingDashboard: false,
}

type SetState = (state: Partial<typeof defaultState>) => void
type UseUserPayload = ReturnType<typeof useUser>

const callbacks = (
  // @ts-expect-error TS2304
  component: keyof typeof componentCallbacks,
  state: typeof defaultState,
  setState: SetState,
  userCallbacks: UseUserPayload['callbacks'],
) => {
  const { editingDashboard } = state
  const { saveUserDashboard } = userCallbacks

  const componentCallbacks = {
    CustomizableDashboard: {
      toggleEditDashboard: () => setState({ editingDashboard: !editingDashboard }),
      saveDashboard: (dashboardKey: string, activeLayout: object) => saveUserDashboard(dashboardKey, activeLayout),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const PageContent = () => {
  const [state, setState] = useSetState(defaultState)
  const { editingDashboard } = state

  const { currentUser } = useCurrentUser()
  const { callbacks: userCallbacks } = useUser(currentUser)

  const customizedLayout = digObject(currentUser, 'options.custom_dashboards.template_manager_dashboard')

  const availableModules = useMemo(() => generateAvailableModules(), [currentUser.id])

  return (
    <PageLayout activeTabBarItemKey="dashboard">
      <CustomizableDashboard
        // @ts-expect-error TS2322
        availableModules={availableModules}
        callbacks={callbacks('CustomizableDashboard', state, setState, userCallbacks)}
        columns={[
          {
            id: 'main',
            component: <Content />,
            title: 'Main',
          },
          {
            id: 'sidebar',
            component: (
              // @ts-expect-error TS2739
              <ContentSidebar
                callbacks={{ customizeDashboard: () => setState({ editingDashboard: !editingDashboard }) }}
                currentUser={currentUser}
              />
            ),
            title: 'Sidebar',
          },
        ]}
        customizedLayout={customizedLayout}
        dashboardKey="template_manager_dashboard"
        dashboardReady={!!currentUser.id}
        defaultLayout={dashboardDefaultLayout}
        editing={editingDashboard}
      />
    </PageLayout>
  )
}

export default PageContent
